import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { LoginResponseDataSchema } from "schema"
import { z } from "zod"

export const useLoginMutation = () => {
  return useMutation({
    mutationFn: async (loginData: object) => {
      const { data } = await axios.post("/auth/login", loginData, { withCredentials: true })
      return data.data as z.infer<typeof LoginResponseDataSchema>
    },
  })
}
